import request from "@/utils/request";
export function fetchDict(type) {
    return request({
        url: '/admin/app/getDict/' + type,
        method: 'get',
    })
}
export function fetchList(query) {
    return request({
        url: '/admin/app/getJobRecruitmentPage',
        method: 'get',
        params: query
    })
}
export function fetchDetail(query) {
    return request({
        url: '/admin/app/getJobRecruitmentPageInfo',
        method: 'get',
        params: query
    })
}
